import {Component, HostListener, Input, OnInit} from '@angular/core';
import {Product} from "../../models/product";
import {ShopService} from "../../modules/shop/service/shop.service";
import {Router} from "@angular/router";
import {animate, state, style, transition, trigger} from "@angular/animations";
import {Carousel} from "tw-elements";
import {goToUrl} from "../../services/util/util";

@Component({
    selector: 'app-top-products',
    templateUrl: './top-products.component.html',
    styleUrls: ['./top-products.component.css'],
    animations: [
        trigger('slideInFromBottom', [
            state('hidden', style({
                transform: 'translateY(40px)',
                opacity: 0
            })),
            state('visible', style({
                transform: 'translateY(0)',
                opacity: 1
            })),
            transition('hidden => visible', animate('0.4s ease-out')),
        ])]
})
export class TopProductsComponent implements OnInit {

    /** How many best sellers to show - eight on the home page, four in the empty cart. */
    @Input()
    limit: number = 8;

    products: Product[] = [];

    selectedProduct!: Product;

    showAnimation: boolean = false;

    constructor(
        private readonly shopService: ShopService,
        protected readonly router: Router
    ) {
    }

    ngOnInit(): void {
        this.getTopSellingProducts();
    }

    setSelectedProduct(product: Product) {
        this.selectedProduct = product;
        // The dialog is not on every page (e.g. search results open the product page instead).
        const carouselElement = document.getElementById("order-dialog-carousel");
        if (carouselElement) {
            new Carousel(carouselElement).to(0);
        }
    }

    @HostListener('window:scroll', ['$event'])
    checkScroll() {
        const componentElement = document.getElementById('topProductsComponent');
        if (componentElement) {
            const rect = componentElement.getBoundingClientRect();
            // Once shown it stays - the heading used to slide away again when scrolled past.
            this.showAnimation = this.showAnimation || (rect.top <= window.innerHeight && rect.bottom >= 0);
        }
    }

    getTopSellingProducts(): void {
        this.shopService.getTopSellingProducts(this.limit).subscribe(products => {
            this.products = products;
            // Already on screen without scrolling (e.g. in the empty cart): show it right away.
            setTimeout(() => this.checkScroll());
        });
    }

    protected readonly goToUrl = goToUrl;
}
